import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSameCategoryMenus } from '@/actions/menu';
import { fetchRelationShoppings } from '@/actions/shopping';
import useMenu from '@/hooks/useMenu';
import useMenuList from '@/hooks/useMenuList';
import useShoppingList from '@/hooks/useShoppingList';

export default function useMenuDetail() {
  const dispatch = useDispatch();
  const [menu, error] = useMenu();
  const menuList = useMenuList();
  const shoppingList = useShoppingList();
  useEffect(() => {
    menu && dispatch(fetchSameCategoryMenus({ menuCat: menu.fields.cat, menuId: menu.fields.id }));
    menu && dispatch(fetchRelationShoppings(menu.fields.relationShoppingList));
  }, [dispatch, menu]);

  return [menu, menuList, shoppingList, error] as const;
}
